module.exports = __webpack_public_path__ + "img/kachel-STRESS_MINDMASTEREXTREME.dfe61c9d.png";